var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"progress-spinner material-icons"},[_vm._v("pending")])}
var staticRenderFns = []

export { render, staticRenderFns }